export const MS_TIME = {
  FIVE_MIN: 300000,
}
